/**
 * Shipment line — org/{orgId}/shipment/{shipmentId}/item
 *
 * ProductRef copied from the SalesOrder line (partial variant). Size distribution (if any)
 * lives on {@link ShipmentItemBreakdown}. Lot on the line is for non-grade products;
 * grade uses lotId on each breakdown row.
 */
export const SHIPMENT_ITEM = 'ShipmentItem';
//# sourceMappingURL=shipment-item.js.map